import React from "react";
import { Chip } from "@mui/material";

export default function Badge({ color, bg, children }) {
  return (
    <Chip
      label={children}
      size="small"
      sx={{
        height: 24,
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: "0.02em",
        color,
        background: bg,
        borderRadius: "999px",
        border: "1px solid transparent",
        "& .MuiChip-label": { px: 1.35 },
      }}
    />
  );
}
